module.exports = __webpack_public_path__ + "img/about_top.7b396784.jpg";